/*
 * Copyright 2025 Intuition Robotics ltd
 */
import React from 'react';
import '../css/style.css';

type ErrorAlertProps = {
	onConfirm: () => void;
	title: string;
	text: string;
	confirmText: string;

};

const ErrorAlert: React.FC<ErrorAlertProps> = ({onConfirm, title, text, confirmText}) => {
	return (
		<div className={'alertContainer active'}>
			<div className="alertOverlay" style={{alignItems: 'center'}}>
				<h2>{title}</h2>
				<p>{text}</p>
				<div className="btnContainer">
					<button className="confirmBtn" onClick={onConfirm}>{confirmText}</button>
				</div>
			</div>
		</div>
	);
};

export default ErrorAlert;